import { useQuery } from "@tanstack/react-query";
import { z } from "zod";
import { authSocialKeys } from "@/lib/query";

const socialProvidersSchema = z.object({
  microsoft: z.boolean(),
});

export type SocialProvidersAvailable = z.infer<typeof socialProvidersSchema>;

export function useSocialProviders() {
  return useQuery({
    queryKey: authSocialKeys.available(),
    queryFn: async (): Promise<SocialProvidersAvailable> => {
      const res = await fetch("/api/auth/social/available", { credentials: "include" });
      if (!res.ok) {
        throw new Error("Failed to load social providers");
      }
      return socialProvidersSchema.parse(await res.json());
    },
    staleTime: 5 * 60_000,
  });
}
